import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import EmailFlowPswResetLayout from "./layouts/EmailFlowPswResetLayout/EmailFlowPswResetLayout";
import PhoneFlowPswResetLayout from "./layouts/PhoneFlowPswResetLayout/PhoneFlowPswResetLayout";
import Navigation from "./components/Navigation/Navigation";
import { CezThemeProvider } from "./theme";
import "./baseCss/baseCSS.css";
import CSSVariables from "./theme/CssVariables";
import MainLayout from "./layoutComponents/MainLayout";
import { ArrowBackButton } from "./components/ArrowBackButton";
import { WebViewProvider } from "./components/WebViewProvider/WebViewProvider";
import { SectionIndicatorContext } from "./shared/contexts/SectionIndicatorContext";

function App() {
    const [sectionNumber, setSectionNumber] = useState<number | null>(null);
    return (
        <WebViewProvider>
            <BrowserRouter>
                <CezThemeProvider>
                    <CSSVariables />
                    <MainLayout>
                        <SectionIndicatorContext.Provider value={{ sectionNumber, setSectionNumber }}>
                            <div>
                                <ArrowBackButton />
                            </div>
                            <Routes>
                                <Route path={process.env.PUBLIC_URL} element={<Navigation />} />
                                <Route path={process.env.PUBLIC_URL + "/psw-email-reset/:token?"} element={<EmailFlowPswResetLayout />} />
                                <Route path={process.env.PUBLIC_URL + "/psw-phone-reset"} element={<PhoneFlowPswResetLayout />} />
                                <Route path="*" element={<Navigation />} />
                            </Routes>
                        </SectionIndicatorContext.Provider>
                    </MainLayout>
                </CezThemeProvider>
            </BrowserRouter>
        </WebViewProvider>
    );
}

export default App;
